import React from "react";
import Banner from "../components/Banner"; // Import Banner component
import ContactCard from "../components/ContactCard";
import ContactForm from "../components/ContactForm";
import GoogleMap from "../components/GoogleMap";
import "../App.css";
import bannerImage from "../images/The_challenge_of_everest_contact_us.jpg"; // Import the image correctly


const Contact = () => {
 

  return (
    <div>
      {/* Banner Section */}
      <Banner 
  bannerImage={bannerImage} 
  title="Contact" 
  style={{ 
    backgroundImage: `url(${bannerImage})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center', 
    height: '400px', // Adjust as needed
    color: 'white', 
    textAlign: 'center', 
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }} 
/>

      {/* Contact Page Content */}
      <div className="contact-page">
        {/* Contact Card Section */}
        <div className="contact-card-container">
          <ContactCard />
        </div>

        {/* Form and Map Section */}
        <div className="contact-content">
          <div className="contact-form">
            <ContactForm />
          </div>
          <div className="google-map">
            <GoogleMap />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
